function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path4146",
    d: "M16,0C7.16,0,0,7.16,0,16c0,8.84,7.16,16,16,16,8.84,0,16-7.16,16-16C32,7.16,24.84,0,16,0h0Zm-7.43,6.82c.47,0,.93,.19,1.26,.53l6.17,6.17,6.17-6.17c.32-.33,.75-.52,1.2-.53,.97-.03,1.77,.73,1.8,1.7,.01,.49-.18,.96-.53,1.31l-6.17,6.17,6.17,6.17c.69,.67,.71,1.78,.03,2.47-.67,.69-1.78,.71-2.47,.03l-.03-.03-6.17-6.17-6.17,6.17c-.67,.69-1.78,.71-2.47,.03s-.71-1.78-.03-2.47l.03-.03,6.17-6.17-6.17-6.17c-.69-.67-.71-1.78-.04-2.47,.33-.34,.78-.53,1.25-.53Z",
    style: {
      fill: "#969696"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel_icon.ec671e1363390e86c0e407d4028ba4aa.svg";
export { ForwardRef as ReactComponent };